<template>
  <div class="home">
    <header class="app-nav">
      <div class="nav-brand">
        <span class="brand-grid"><i></i><i></i><i></i><i></i></span>
        <div>
          <strong>SYLVOX</strong>
          <span>产品服务平台</span>
        </div>
      </div>
      <nav class="nav-links" aria-label="已访问菜单">
        <button v-for="item in headerTabs" :key="item.path" :class="{active: $route.path === item.path}" @click="navigate(item.path)">
          <el-icon><component :is="item.icon" /></el-icon>
          {{ item.title }}
        </button>
      </nav>
      <UserAndImage :is-left="isLeft" in-header></UserAndImage>
    </header>
    <div class="workspace">
      <div class="tableList">
        <el-menu
            :default-active="0"
            :unique-opened="true"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
        >
          <div v-for="(item,index) in tableList" :key="index">
            <el-sub-menu  v-if="item.children && item.children.length>0"  :index="index"  >
              <template #title>
                <el-icon :class="{'is-loading': item.meta.icon === 'Loading'}"><component :is="item.meta.icon" /></el-icon>
                <span>{{item.meta.title}}</span>
              </template>
              <el-menu-item @click="goTo(citem)" v-for="(citem,cindex) in item.children" :index="index+'-'+cindex" :key="index+'-'+cindex">
                <div>
                  <el-icon :class="{'is-loading': citem.meta.icon === 'Loading'}"><component :is="citem.meta.icon" /></el-icon>
                  <span>{{citem.meta.title}}</span>
                </div>
              </el-menu-item>
            </el-sub-menu>
            <el-menu-item @click="goTo(item)" v-else :index="index">
              <el-icon :class="{'is-loading': item.meta.icon === 'Loading'}"><component :is="item.meta.icon" /></el-icon>
              <span>{{item.meta.title}}</span>
            </el-menu-item>
          </div>
        </el-menu>
      </div>
      <div class="other-view">
        <router-view></router-view>
      </div>
    </div>
  </div>

</template>

<script>
import UserAndImage from "../components/UserAndImage.vue";
import {ElMenu,ElSubMenu,ElMenuItem,ElIcon} from "element-plus";
import {permission} from "../utils/storage"
export default {
  name: 'MenuTable',
  components: {
    UserAndImage,ElMenu,ElSubMenu,ElMenuItem,ElIcon
  },
  data() {
    return {
      isLeft:false,
      tabIndex:0,
      // 顶部仅展示用户已经打开过的左侧菜单，首页固定保留。
      headerTabs: [
        {title: "首页", icon: "HomeFilled", path: "/"}
      ],
      tableList: [
          {path:"/",meta:{icon:"HomeFilled",title:"首页"}},

          {
            meta:{icon:"Menu",title:"看板管理"},
            children: [
              {path:"/saleOrder",meta:{icon:"Menu",title:"销售看板"}},
            ]
          },
          {
            meta:{icon:"Van",title:"物流管理"},
            children:[
              {path:'/contrast',meta:{icon:"Menu",title:"尾程费用"} },
              {path:'/',meta:{icon:"Menu",title:"头程费用"} },
              {path:'/',meta:{icon:"Menu",title:"费用定义"} },
              {path:'/',meta:{icon:"Menu",title:"仓库管理"} },
              {path:'/',meta:{icon:"Menu",title:"物流商列表"} },
            ]
          },
          {
            meta:{icon:'Service',title:"售后管理"},
            children: [
              {path:'/',meta:{icon:"Menu",title:"未激活列"} },
              {path:'/',meta:{icon:"Menu",title:"保修激活"} },
              {path:'/',meta:{icon:"Menu",title:"售后维修"} },
              {path:'/',meta:{icon:"Menu",title:"流程定义"} },
            ]
          },
          {
            meta:{icon:'Notebook',title:"组织架构"},
            children: [
              {path:'/kMumber',meta:{icon:"Menu",title:"账号管理"} },
              {path:'/kDepartment',meta:{icon:"Menu",title:"部门管理"} },
              {path:'/',meta:{icon:"Menu",title:"菜单配置"} },
            ]
          },
          {
            meta:{icon:'Operation',title:"基础数据"},
            children: [
              {path:'/',meta:{icon:"Menu",title:"商品管理"} },
              {path:'/',meta:{icon:"Menu",title:"客户管理"} },
            ]
          },
          {
            meta:{icon:'Document',title:"数据管理"},
            children: [
              {path:'/tools',meta:{icon:"Menu",title:"API管理"} },
              {path:'/',meta:{icon:"Menu",title:"应用管理"} },
              {path:'/',meta:{icon:"Menu",title:"数据采集"} },
            ]
          },
          {path:"/tools",meta:{icon:'Setting',title:"OA流程"}}
      ],
    }
  },
  methods:{
    navigate(path) {
      this.$router.push({path});
    },
    goTo(item){
      if (item.path =='/saleOrder') {
        this.isLeft = true;
      }else{
        this.isLeft = false;
      }
      this.addHeaderTab(item);
      this.$router.push({path:item.path});
    },
    addHeaderTab(item) {
      if (!item || !item.path || this.headerTabs.some(tab => tab.path === item.path)) {
        return;
      }
      this.headerTabs.push({
        title: item.meta?.title || "未命名菜单",
        icon: item.meta?.icon || "Menu",
        path: item.path
      });
    },
    findMenuItem(path, menus = this.tableList) {
      for (const item of menus) {
        if (item.path === path) return item;
        if (item.children) {
          const match = this.findMenuItem(path, item.children);
          if (match) return match;
        }
      }
      return null;
    },
    addCurrentRouteTab(path) {
      const menuItem = this.findMenuItem(path);
      if (menuItem) {
        this.addHeaderTab(menuItem);
        return;
      }
      const title = this.$route.meta?.title;
      if (path !== "/" && title) {
        this.addHeaderTab({path, meta: {title, icon: "Menu"}});
      }
    },
    handleOpen(key, keyPath){
      console.log(key, keyPath)
    },
    handleClose (key, keyPath){
      console.log(key, keyPath)
    }
  },
  beforeMount() {
    try {
      let tableList  =JSON.parse(localStorage.getItem("permission"))
      if (tableList && tableList.length > 0) {
        this.tableList = tableList
      }else{
        this.tableList  =permission
      }
    }catch(e){
      console.log(e)
    }
    let route = this.$router.currentRoute.value.path;
    if (route =='/') {
      this.isLeft = true;
    }else{
      this.isLeft = false;
    }
  },
  watch: {
    "$route.path"(path) {
      this.addCurrentRouteTab(path);
    }
  }
}
</script>

<style scoped>
.home{
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.app-nav {
  align-items: center;
  background:
    linear-gradient(90deg, rgba(3, 48, 31, .94), rgba(6, 59, 40, .82)),
    url("../../public/login-patio-background.png") center 52% / cover no-repeat;
  box-shadow: 0 1px 0 rgba(218, 242, 224, .16) inset;
  box-sizing: border-box;
  display: flex;
  flex: 0 0 76px;
  gap: 52px;
  justify-content: space-between;
  padding: 0 42px 0 28px;
}
.nav-brand { align-items: center; color: #fff; display: flex; flex: 0 0 270px; gap: 12px; }
.nav-brand strong { display: block; font-size: 20px; letter-spacing: 1.2px; line-height: 1.1; }
.nav-brand span { color: #b9dac2; display: block; font-size: 12px; margin-top: 4px; }
.brand-grid { display: grid; gap: 3px; grid-template-columns: repeat(2, 15px); }
.brand-grid i { background: #e5f3e8; height: 15px; opacity: .9; width: 15px; }
.brand-grid i:nth-child(2), .brand-grid i:nth-child(3) { opacity: .52; }
.nav-links { align-items: center; display: flex; flex: 1; gap: 12px; justify-content: center; }
.nav-links button { align-items: center; background: transparent; border: 0; border-radius: 9px; color: #c6ddcc; cursor: pointer; display: inline-flex; font-size: 15px; font-weight: 600; gap: 7px; padding: 12px 17px; }
.nav-links button:hover, .nav-links button.active { background: rgba(151, 208, 168, .22); color: #fff; }
.workspace { display: flex; flex: 1; min-height: 0; }
.tableList{
  background: #063b28;
  width: 200px;
  height: 100%;
  overflow-y: auto; /* 垂直方向超出时显示滚动条 */

  /* 隐藏所有浏览器的滚动条 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 和 Edge */
}

.tableList::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

::v-deep .el-menu {
  --el-menu-active-color: #ffffff;
  --el-menu-bg-color: #063b28;
  --el-menu-hover-bg-color: #0b5436;
  --el-menu-text-color: #ddf2e3;
}

.other-view{
  flex: 1;
  max-height: 100%;
  overflow: hidden;
}
</style>
